import { getOrders } from './orderService';
import { getInventoryItems } from './inventoryService';

export async function getNotifications() {
  try {
    const [orders, inventory] = await Promise.all([
      getOrders(),
      getInventoryItems()
    ]);

    const today = new Date().toISOString().split('T')[0];

    // Identify notifications similar to previous logic in Header
    const inventoryAlerts = inventory
      .filter((item) => {
        const quantityOnHand = parseInt(item.quantity_on_hand, 10);
        const minimumStockLevel = parseInt(item.minimum_stock_level, 10);
        const maximumStockLevel = parseInt(item.maximum_stock_level, 10);
        const reorderPoint = parseInt(item.reorder_point, 10);
        const expiryDate = item.expiry_date;
        const excessInventory = item.excess_inventory;

        return (
          (minimumStockLevel && quantityOnHand < minimumStockLevel) ||
          (maximumStockLevel && quantityOnHand > maximumStockLevel) ||
          (reorderPoint && quantityOnHand <= reorderPoint) ||
          excessInventory ||
          (expiryDate && expiryDate <= today)
        );
      })
      .map((item) => ({
        type: 'Inventory',
        id: item.product_id,
        issue: getIssueDescription(item),
        isNew: true,
      }));

    const orderAlerts = orders
      .filter((order) => {
        const deliveryDate = order.delivery_date;
        const orderStatus = order.order_status;
        return (
          deliveryDate &&
          deliveryDate < today &&
          orderStatus !== 'Completed' &&
          orderStatus !== 'Cancelled'
        );
      })
      .map((order) => ({
        type: 'Order',
        id: order.order_id,
        issue: 'Order overdue for delivery',
        isNew: true,
      }));

    return [...inventoryAlerts, ...orderAlerts];
  } catch (error) {
    console.error('Error fetching notifications:', error);
    return [];
  }
}

function getIssueDescription(item) {
  const issues = [];
  const quantityOnHand = parseInt(item.quantity_on_hand, 10);
  const minimumStockLevel = parseInt(item.minimum_stock_level, 10);
  const maximumStockLevel = parseInt(item.maximum_stock_level, 10);
  const reorderPoint = parseInt(item.reorder_point, 10);
  const today = new Date().toISOString().split('T')[0];

  if (minimumStockLevel && quantityOnHand < minimumStockLevel) {
    issues.push('Below Minimum Stock Level');
  }
  if (maximumStockLevel && quantityOnHand > maximumStockLevel) {
    issues.push('Above Maximum Stock Level');
  }
  if (reorderPoint && quantityOnHand <= reorderPoint) {
    issues.push('At or Below Reorder Point');
  }
  if (item.excess_inventory) {
    issues.push('Excess Inventory');
  }
  if (item.expiry_date && item.expiry_date <= today) {
    issues.push('Expired');
  }

  return issues.join(', ');
}
